import { useState } from "react";
import { useSignup } from "../hooks/useSignup";

const Signup = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");
    const [code, setCode] = useState(""); // New state variable for the code
    const { error, isLoading, signup } = useSignup();

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevents page from refreshing
        console.log("Code is", code);
        
        await signup(email, password, code); // Include code in the signup function
    }

    const checkCriteria = (password, password2) => {
        return {
            length: password.length >= 8,
            lowercase: /[a-z]/.test(password),
            uppercase: /[A-Z]/.test(password),
            number: /\d/.test(password),
            symbol: /[@$!%*?&]/.test(password),
            match: password.length > 0 && password === password2

        };
    };

    const criteria = checkCriteria(password, password2, code);
    const allCriteriaMet = criteria.length && criteria.lowercase && criteria.uppercase && criteria.number && criteria.symbol && criteria.match;

    return(
        <form className="signup" onSubmit={handleSubmit}>
            <h3> Signup</h3>

            <label>Email:</label>
            <input
                type = "email"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
            />
            <label>Password:</label>
            <input
                type = "password"
                onChange={(e) => setPassword(e.target.value)}
                value={password}
            />

            <label>Re-enter Password:</label>
            <input
                type = "password"
                onChange={(e) => setPassword2(e.target.value)}
                value={password2}
            />

            <label>Access Code:</label> {/* New input field for the code */}
            <input
                type="text"
                onChange={(e) => setCode(e.target.value)}
                value={code}
            />


            <div className="login_mechanisms">
                <ul className="password-requirements">
                    <li style={{ color: criteria.length ? 'green' : 'grey' }}>&#8226; At least 8 characters</li>
                    <li style={{ color: criteria.lowercase ? 'green' : 'grey' }}>&#8226; At least 1 lowercase letter</li>
                    <li style={{ color: criteria.uppercase ? 'green' : 'grey' }}>&#8226; At least 1 uppercase letter</li>
                    <li style={{ color: criteria.number ? 'green' : 'grey' }}>&#8226; At least 1 number</li>
                    <li style={{ color: criteria.symbol ? 'green' : 'grey' }}>&#8226; At least 1 symbol</li>
                    <li style={{ color: criteria.match ? 'green' : 'grey' }}>&#8226; Passwords match</li>


                </ul>
            </div>

            <button
                type="submit"
                className={`submit-button ${!allCriteriaMet || isLoading ? 'disabled' : ''}`}
                disabled={!allCriteriaMet || isLoading}
                style={{ backgroundColor: !allCriteriaMet || isLoading ? 'lightgrey' : '#242424' }}
            >
                Signup
            </button>
            {error && <div className="error">{error}</div>}


        </form>
    )
}

export default Signup;